import { useGA, useGaContextState } from '@/hooks/useGA';
import { createContext } from 'react';

export const GaContext = createContext({} as useGaContextState);

type Props = {
    children: JSX.Element;
};
export const GaContextProvider = (props: Props) => {
    const { children } = props;
    const sm = useGA();
    return <GaContext.Provider value={sm}>{children}</GaContext.Provider>;
};
